module.exports = __webpack_public_path__ + "static/img/celan_btn.c735ecae.png";